module.exports = __webpack_public_path__ + "img/source3.94e0664c.png";